export default __webpack_public_path__ + "static/media/ribbon-recommended-value.0664668d.png";